
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.724 13.724a5.09 5.09 0 11-7.198-7.198 5.09 5.09 0 017.198 7.198zm.243 2.403a7.125 7.125 0 112.16-2.16L22 19.843l-2.16 2.16-5.873-5.875z","fill":"currentColor"}})])
          )
        }
      }
    